<form [formGroup]="couponForm">
  <p class="mb-2">Utiliser un code de réduction ?</p>
  <div class="container-coupon-input">
    <mat-form-field class="coupon-input">
      <mat-label>Code de réduction</mat-label>
      <input matInput formControlName="name" placeholder="" type="text">
    </mat-form-field>
    <button (click)="submit()" class="btn-coupon">
      Appliquer
    </button>
  </div>
  <div class="container-coupon-state text-success" *ngIf="successMessage != null && errorMessage === null">
    <img ngSrc="/assets/images/payment-success.svg" width="16" height="16" alt>
    {{successMessage}}
  </div>
  <div class="container-coupon-state text-error" *ngIf="errorMessage != null && successMessage === null">
    <img ngSrc="/assets/images/payment-error.svg" width="16" height="16" alt>
    {{errorMessage}}
  </div>
</form>
